import React, { Suspense, useState, useEffect } from "react";
import Drawer from 'react-modern-drawer';
import projectServices from "./projectServices";
import { CommonUtilities } from "../../commonUtils";
import { SelectContact } from "../Contacts/selectContact";
import ClassListing from "./classListing";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function EditProject(param: any) {

    let [invalidField, setinvalidField] = useState(false)
    let [projectContact, setprojectContact] = useState(false)
    let [projectClass, setprojectClass] = useState(false)
    let [isActiveTab, setisActiveTab] = useState("general")
    const [Available, initAvailable] = useState<any>([]);
    const [Associated, initAssociated] = useState<any>([]);
    const [projectDetail, initprojectDetail] = useState<any>([]);

    useEffect(() => {
        initprojectDetail(param.projectDetails)
        apiCall();
    }, [param.openeditProject]);

    const apiCall = () => {
        var tagColorList = cachingMechanisum.getCachingStorage("tagColor");
        var temp2 = tagColorList?.filter((lookUpListItem: any) => lookUpListItem.lookUpType === "projectTag");

        if (param?.projectDetails?.projectId) {
            projectServices.getProjectTag({
                area: 'projectType',
                referenceCode: param?.projectDetails?.projectId
            }).then((res) => {
                initAssociated(res);

                for (var i = 0; i < temp2.length; i++) {

                    var found = res?.filter((lookUpListItem: any) => lookUpListItem.text === temp2[i].itemName);
                    var already = Available?.filter((lookUpListItem: any) => lookUpListItem.itemName === temp2[i].itemName);
                    if (found.length === 0 && already.length === 0) {
                        Available.push(temp2[i]);
                        initAvailable(Available);
                    }
                }
            })
        }
    }

    const closeEditForm = () => {
        param.closeEditForm();
    }

    const SelectContactImprint = (e: any) => {
        console.log(e)
        if (e === "close") {
            setprojectContact(false)
        }

        if (e.type === "kontact") {
            console.log(e.data)

            initprojectDetail((prevState: any) => ({
                ...prevState,
                kontactDisplay: e.data.kontactDisplay,
                kontactCode: e.data.kontactCode
            }));
        }

        setprojectClass(false)
    }

    const SelectClassName = (e: any) => {
        console.log(e)
        if (e === "close") {
            setprojectClass(false)
        }

        if (e !== "close") {
            initprojectDetail((prevState: any) => ({
                ...prevState,
                classList: e.classList
            }));
        }

        setprojectClass(false)
    }

    const removeProjectTag = (e: any) => {
        console.log(e)
        projectServices.removeProjectTag(e.id).then(() => {
            apiCall();
        })
    }

    const addProjectTag = (e: any) => {
        console.log(e)

        var payload = {
            area: "projectType",
            code: e.iD,
            isActive: 1,
            isCustom: 1,
            referenceCode: projectDetail?.projectId,
            text: e.value
        }

        projectServices.addProjectTag(payload).then(() => {
            apiCall();
        })
    }

    const saveParentProject = () => {
        projectServices.projectSave(projectDetail).then(() => {
            apiCall();
        })
    }

    const downloadReport803 = () => {
        var payload = {
            template: "Reports/Crystal803.rpt",
            projectCode: param.projectDetails.projectCode,
            periodNum: ""
        }
        projectServices.downloadReport803(payload).then(() => {
            apiCall();
        })
    }
    return (
        <>
            <Drawer
                open={param.openeditProject}
                direction='right'
                className='react-drawer-left full-height-vh allowHscroll' style={{ width: "100%", height: "100%" }}>
                <div className="ws-9 box pull-right" style={{ minHeight: "800px" }}>

                    <div className="box-header-main">
                        <h2>Edit Project Details</h2>
                    </div>

                    <div className="box-content">

                        {isActiveTab === "general" && <div ng-include="currentTabProject">
                            <div className="box-content">

                                <div className="ws-12">
                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">Project name:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.projectName}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">License Type:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.classList}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">Project code:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.projectCode}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">Project ID:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.projectId}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">Project Type:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.projectType}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-2 pm">
                                        <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                            <label className="ws-12 text-left mts text-bold">Project Status:</label>
                                            <div className="label-entries text-right ws-12 text-m mtl mb">
                                                {projectDetail?.status}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {invalidField && <div className="alert alert-danger">
                                    There was a problem submitting your request, one or more fields are missing or incorrect.
                                </div>}

                                <div className="ws-12">
                                    <div className="ws-6">

                                        <div className="form-format">
                                            <label>Name*</label>
                                            <div className="label-entries">
                                                <input type="text" placeholder="Name" name="projectName" value={projectDetail?.projectName} required />
                                                <div className="alert alert-info hide" >
                                                    Project Name should be at least 4  characters long
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-format">
                                            <label>ID</label>

                                            <div className="label-entries">
                                                <input type="text" value={projectDetail?.projectId} name="licenseWith" placeholder="Autogenerated Project ID" readOnly ng-model="createProjectDetails.projectId" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-6">

                                        <div className="form-format">
                                            <label>Owner</label>
                                            <div className="label-entries">
                                                <input type="text" placeholder="Owner" name="projectOwner" value={projectDetail?.projectOwner} />
                                            </div>

                                        </div>
                                        <div className="form-format">
                                            <label>Code</label>
                                            <div className="label-entries">
                                                <input type="text" placeholder="Autogenerated Project Code" name="projectCode" readOnly value={projectDetail?.projectCode} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format ws-12">
                                    <label><strong>Creator/Live</strong></label>
                                </div>

                                <div className="form-format ws-6">
                                    <label>Contact*</label>

                                    <div className="label-entries">
                                        <div className="ws-11">
                                            <input type="text" name="contact" placeholder="Enter contact" value={projectDetail?.kontactDisplay} required onClick={() => setprojectContact(true)} />
                                        </div>

                                        <div className="ws-1">
                                            <button type="button" className="icon-btn primary" onClick={() => setprojectContact(true)}><i className="icon-user-add"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format ws-6">
                                    <label>MPM/Class</label>

                                    <div className="label-entries">
                                        <div className="ws-11">
                                            <input type="text" onClick={() => setprojectClass(true)} name="licenseWith" placeholder="Enter MPM/Class" value={projectDetail?.classList} />
                                        </div>

                                        <div className="ws-1">
                                            <button type="button" onClick={() => setprojectClass(true)} className="icon-btn primary">Select</button>
                                        </div>
                                    </div>
                                </div>

                                {projectDetail?.projectCode && <div className="ws-6">

                                    <div className="ws-6 pm">
                                        <div className="box">
                                            <div className="box-header">
                                                <h3 className="panel-title">Available</h3>
                                            </div>
                                            <div className="box-content">

                                                {
                                                    Available?.map((values: any) => {
                                                        return (
                                                            <ul className="listStyle pLarge">

                                                                <a className="btn ws-12 ms p0 maxWidth"
                                                                    style={{
                                                                        background: CommonUtilities.lookUpTypeList('projectTag', values.itemName, 'bgColor'),
                                                                        color: CommonUtilities.lookUpTypeList('projectTag', values.itemName, 'fontColor')
                                                                    }} >
                                                                    <span className="mts mb ws-10 text-center">{values.itemName}</span>
                                                                    <span className="pull-right ws-2 mtss" onClick={() => addProjectTag(values)}>
                                                                        <i className="icon-cancel1 text-xl"></i>
                                                                    </span>
                                                                </a>
                                                            </ul>
                                                        )
                                                    })
                                                }

                                                {Available.length === 0 && <span > No Tags Available </span>}
                                            </div>

                                        </div>
                                    </div>

                                    <div className="ws-6 pm">
                                        <div className="box">
                                            <div className="box-header">
                                                <h3 className="panel-title">Associated</h3>
                                            </div>
                                            <div className="box-content">

                                                {
                                                    Associated?.map((values: any) => {
                                                        return (
                                                            <ul className="listStyle pLarge">

                                                                <a className="btn ws-12 ms p0 maxWidth"
                                                                    style={{
                                                                        background: CommonUtilities.lookUpTypeList('projectTag', values.text, 'bgColor'),
                                                                        color: CommonUtilities.lookUpTypeList('projectTag', values.text, 'fontColor')
                                                                    }} >
                                                                    <span className="mts mb ws-10 text-center">{values.text}</span>
                                                                    <span className="pull-right ws-2 mtss" onClick={() => removeProjectTag(values)}>
                                                                        <i className="icon-cancel1 text-xl"></i>
                                                                    </span>
                                                                </a>
                                                            </ul>
                                                        )
                                                    })
                                                }
                                            </div>

                                        </div>
                                    </div>

                                </div>}

                            </div>

                            <div className="box-footer">

                                <button className="icon-btn delete" onClick={closeEditForm}>
                                    <i className="fa fa-close"></i> Close
                                </button>

                                <button className="icon-btn delete" type="button" onClick={downloadReport803}>
                                    <i className="icon-file-pdf-o"></i>
                                </button>

                                <button className="btn-info btn-sm hide" ng-click="assetsManager(createProjectDetails);">
                                    Song/Track
                                </button>

                                <button className="icon-btn primary" ng-click="assetsManager(createProjectDetails);" ng-show="createProjectDetails.projectId">
                                    Assets
                                </button>

                                <button className="icon-btn edit" onClick={saveParentProject}>
                                    <i className="icon-save"></i> Save
                                </button>


                                <button className="icon-btn primary hide" ng-click="projectFileUpload(relativeDataValue(contractIndex, 'projectId'), relativeDataValue(contractIndex, 'projectCode'), relativeDataValue(contractIndex, 'projectName'));">
                                    <i className="icon-upload"></i>
                                    Upload
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="projectDescription(relativeDataValue(contractIndex, 'projectId'));">
                                    <i className="icon-eye"></i>
                                    Add / View
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="projectFileUploadSource(relativeDataValue(contractIndex, 'projectId'));">
                                    <i className="icon-soundcloud"></i>
                                    Source
                                </button>

                                <button className="icon-btn edit btn-xs hide" ng-click="projectUserManager(relativeDataRemapping(contract));">
                                    <i className="icon-user-add"></i>
                                    Users
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="newParentProject(relativeDataValue(contractIndex, 'licenseProjectType'), relativeDataValue(contractIndex, 'projectId'), contractIndex);">
                                    <i className="icon-pen"></i>
                                    Edit
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="newProject(relativeDataValue(contractIndex, 'licenseProjectType'), relativeDataValue(contractIndex, 'projectId'), contractIndex);">
                                    <i className="icon-pen"></i>
                                    Edit
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-show="relativeDataValue(contractIndex, 'licenseProjectType')  === 'Creator'" ng-click="teamManager(relativeDataRemapping(contract));">
                                    <i className="icon-user-solid-circle"></i>
                                    Team
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="assetsManager(relativeDataRemapping(contract));">
                                    <i className="icon-coins"></i>
                                    Assets
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="newCreatorSongTrack('Creator', relativeDataValue(contractIndex, 'projectId'), contractIndex, true);" data-ng-show="relativeDataValue(contractIndex, 'licenseProjectType')  === 'Creator'">
                                    <i className="icon-track"></i>
                                    Song/Track
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="newCreatorRelease('Creator', relativeDataValue(contractIndex, 'projectId'), contractIndex, true);" data-ng-show="relativeDataValue(contractIndex, 'licenseProjectType')  === 'Creator'">
                                    <i className="icon-coins"></i>
                                    Release
                                </button>

                                <button className="icon-btn primary btn-xs hide" ng-click="newProject(relativeDataValue(contractIndex, 'licenseProjectType'), relativeDataValue(contractIndex, 'projectId'), contractIndex, true);">
                                    <i className="icon-Recorded_Music"></i>
                                    Data Analytics,Queue Grouping,Royalty Terms
                                </button>

                                <button className="icon-btn delete hide" ng-click="deleteProject(relativeDataValue(contractIndex, 'projectId'));">
                                    <i className="icon-trash"></i>
                                    Delete
                                </button>


                            </div>
                        </div>}

                    </div>

                </div>
            </Drawer>

            {(() => {
                if (projectContact) {
                    return <SelectContact SelectContactImprint={SelectContactImprint} data={projectDetail} open={projectContact} hideTab={true} />
                }

                if (projectClass) {
                    return <ClassListing closeClassListing={SelectClassName} data={projectDetail} open={projectClass} />
                }

            })()}

        </>
    )

}